import Model from "../../model"
import { ID, HexColor } from "../../types"
import * as _ from "lodash"

import Command, { CommandName } from "../command"

export type ColourIdeasCommandState = {
  idColours: [ID, HexColor][]
  updatedAt?: Date
  captured?: {
    inverseIdColours: [ID, HexColor][]
  }
}

export default class ColourIdeasCommand extends Command {
  name: CommandName = "colour-ideas"
  state: ColourIdeasCommandState

  constructor(state: ColourIdeasCommandState) {
    super()
    this.state = state
  }

  // Possible conflicts:
  //   - idea has been deleted (Resolve, Cancel)
  resolveConflicts(model: Model): ColourIdeasCommandState | null {
    const newIdColours = this.state.idColours.filter(([id, _]) => {
      return !!model.getIdea(id)
    })
    if (newIdColours.length)
      return { ..._.cloneDeep(this.state), idColours: newIdColours }
    else return null
  }

  local(model: Model): any {
    const inverseIdColours: [ID, HexColor][] = []
    this.state.idColours.forEach(([id, _]) =>
      inverseIdColours.push([id, model.fetchIdea(id).colour as HexColor])
    )
    this.state.captured = { inverseIdColours }

    model.colourIdeas(this.state.idColours, this.state.updatedAt)
  }

  undo(): Command[] {
    if (!this.state.captured) throw new Error("Undo state not set")
    return [
      new ColourIdeasCommand({
        idColours: this.state.captured.inverseIdColours,
      }),
    ]
  }

  merge(previous: ColourIdeasCommand | undefined): Command | undefined {
    // Only recolouring the same ideas again merges (dragging through the colour picker).
    if (
      previous instanceof ColourIdeasCommand &&
      _.isEqual(
        this.state.idColours.map(([id, _colour]) => id),
        previous.state.idColours.map(([id, _colour]) => id)
      )
    ) {
      const merged = new ColourIdeasCommand({ idColours: this.state.idColours })
      merged.state.captured = previous.state.captured
      return merged
    }
  }
}
